export type ExpoDevMenu = {
  openMenu();
  openProfile();
  openSettings();
};
